import React, { useEffect, useState } from 'react'
import './EleLocal.css';
import GujaratVideo from '../../../assets/Gujarat.mp4';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import HttpService from '../../../utils/httpService';
import { FaUniversity } from 'react-icons/fa';

const EleLocalCMP = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [assemblyData, setAssemblyData] = useState([]);

    const isHomePage = location.pathname === '/';
    const isDashboardMode = location.pathname === '/gujarat-election-2026-live' || location.search.includes('dashboard=true');

    const slugify = (text) => {
        return (text || "").toString().toLowerCase().trim()
            .replace(/\s+/g, '-')
            .replace(/[^\w-]+/g, '')
            .replace(/--+/g, '-');
    };

    useEffect(() => {
        axios.get(HttpService.seatTally)
            .then(res => {
                if (res.data && res.data.data) {
                    const customOrder = ["WESTBENGAL", "TAMILNADU", "ASSAM", "KERALA", "PUDUCHERRY"];
                    const sortedData = [...res.data.data].sort((a, b) => {
                        const nameA = (a.state_name || "").replace(/\s/g, "").toUpperCase();
                        const nameB = (b.state_name || "").replace(/\s/g, "").toUpperCase();
                        const indexA = customOrder.indexOf(nameA);
                        const indexB = customOrder.indexOf(nameB);
                        if (indexA === -1 && indexB === -1) return 0;
                        if (indexA === -1) return 1;
                        if (indexB === -1) return -1;
                        return indexA - indexB;
                    });
                    setAssemblyData(sortedData);
                }
            })
            .catch(err => console.error("Assembly Tally Error:", err));
    }, []);

    return (
        <div className="ele-local-body ele-screen-lock-console container">
           {!isHomePage && <div className="ele-vault-split glass-panel">
                {/* --- LEFT: CINEMATIC MAP STAGE --- */}
                <div className="cmp-map-focus-lock" onClick={() => navigate(`/local-body-election-2026${isDashboardMode ? '?dashboard=true' : ''}`)}>
                    <div className="cmp-vault-title-group">
                        <span className="cmp-region-badge-mini">ELECTION</span>
                        <h1 className="cmp-guj-heading-mini">ગુજરાત</h1>
                        <span className="cmp-sub-heading-mini">સ્થાનિક સ્વરાજ્ય ચૂંટણી</span>
                    </div>
                    <div className="cmp-map-3d-float">
                        <video
                            src={GujaratVideo}
                            autoPlay
                            loop
                            muted
                            playsInline
                            className="cmp-map-svg-compact"
                        />
                    </div>
                </div>

                {/* --- RIGHT: TACTICAL COMMAND RAIL --- */}
                <div className="cmp-right-rail tactical-glass-card">
                    <div className="cmp-rail-header">
                        <div className="cmp-mission-group">
                            <span className="cmp-mission-badge">MISSION CONTROL</span>
                            <span className="cmp-sync-subtext">SYNC STATUS: ACTIVE</span>
                        </div>
                        <div className="cmp-live-pulse-container">
                            <span className="cmp-pulse-core-mini"></span>
                            <span className="cmp-live-label-mini">LIVE ચૂંટણી 2026</span>
                        </div>
                    </div>

                    <div className="cmp-tabs-column">
                        <div className="cmp-tab-node">
                            <span className="cmp-tab-lbl">કુલ વિસ્તાર <span className="cmp-tab-lbl-eng">(TOTAL AREA)</span></span>
                            <div className="cmp-tab-val-group">
                                <strong className="cmp-tab-num">1,96,024</strong>
                                <span className="cmp-tab-unit">KM²</span>
                            </div>
                        </div>

                        <div className="cmp-tab-node">
                            <span className="cmp-tab-lbl">કુલ વસ્તી <span className="cmp-tab-lbl-eng">(TOTAL POPULATION)</span></span>
                            <div className="cmp-tab-val-group">
                                <strong className="cmp-tab-num">6,04,39,692</strong>
                                <span className="cmp-tab-unit">APROX</span>
                            </div>
                        </div>

                        <div className="cmp-tab-node">
                            <span className="cmp-tab-lbl">જિલ્લાઓ <span className="cmp-tab-lbl-eng">(DISTRICTS)</span></span>
                            <div className="cmp-tab-val-group">
                                <strong className="cmp-tab-num">34</strong>
                                <span className="cmp-tab-unit">DIST</span>
                            </div>
                        </div>
                    </div>

                    <div className="cmp-action-lock">
                        <button
                            className="cmp-cinematic-trigger-compact"
                            onClick={() => navigate(`/local-body-election-2026${isDashboardMode ? '?dashboard=true' : ''}`)}
                        >
                            <span className="cmp-btn-glint"></span>
                            <span>LOCAL BODY ELECTION</span>
                            <svg className="cmp-btn-icon-mini" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>}

            {/* --- NEW ASSEMBLY ELECTION NAV SECTION --- */}
                <div className="assembly-nav-container glass-panel">
                    <button className="assembly-action-btn" onClick={() => navigate(`/assembly-election${isDashboardMode ? '?dashboard=true' : ''}`)}>
                        <FaUniversity className="btn-icon-fa" />
                        Assembly Elections
                    </button>
                    <div className="assembly-state-tabs">
                        {assemblyData.map((state) => (
                            <div
                                key={state.state_id}
                                className="state-tab-item"
                                onClick={() => navigate(`/assembly-election?state=${slugify(state.state_name)}${isDashboardMode ? '&dashboard=true' : ''}`)}
                            >
                                <div className="tab-live-pulse-node">
                                    <span className="tab-pulse-dot"></span>
                                    <span className="tab-live-txt">LIVE</span>
                                </div>
                                <span className="st-guj">{state.state_name_guj}</span>
                                <span className="st-eng">{state.state_name}</span>
                            </div>
                        ))}
                    </div>
                </div>           
        </div>
    )
}

export default EleLocalCMP;